exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".api-notes{margin:10px;margin-bottom:64px}.api-notes .description{margin-bottom:16px}.api-notes .notes-item{padding:8px 4px;display:flex;align-items:center}.api-notes .notes-item .value{margin-left:8px}.api-notes .notes-item:nth-child(odd){background-color:#101012}", ""]);

